"use strict";

var React = require('react');

function ModalTitle(props) {
  return React.createElement(
    "h4",
    { className: "cf-modal__title" },
    props.children
  );
}

module.exports = ModalTitle;